<script>
    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import timeGridPlugin from '@fullcalendar/timegrid'
    import interactionPlugin from '@fullcalendar/interaction'
    import { INITIAL_EVENTS, createEventId } from './event-utils'

    export default {

        components: {
            FullCalendar // make the <FullCalendar> tag available
        },

        data: function() {
            return {
                clickedevent:'',
                allTasks:'',
                appointmentform:{
                    task:'',
                    start_time:'',
                    end_time:'',
                    selected_date:'',
                },
                calendarOptions: {
                    plugins: [
                        dayGridPlugin,
                        timeGridPlugin,
                        interactionPlugin // needed for dateClick
                    ],
                    headerToolbar: {
                        right: 'prev,next today',
                        center: 'title',
                        left: ''
                    },
                    initialView: 'dayGridMonth',
                    events: {
                        url: '/api/tasks',
                        method: 'POST',
                        failure: function() {
                            console.log('there was an error while fetching events!');
                        },
                        color: 'yellow',   // a non-ajax option
                        textColor: 'black' // a non-ajax option
                    },
                    editable: true,
                    selectable: true,
                    selectMirror: true,
                    dayMaxEvents: true,
                    weekends: true,

                    select: this.handleDateSelect,
                    eventClick: this.handleEventClick,
                    eventsSet: this.handleEvents
                    /* you can update a remote database when these fire:
                    eventAdd:
                    eventChange:
                    eventRemove:
                    */
                },
                currentEvents: [],
                dayevents:'',
                selected_date:'',
            }
        },
        mounted(){
            this.GetTasks()
        },


        methods: {


            handleDateSelect(selectInfo) {
                // let title = prompt(selectInfo);
                let calendarApi = selectInfo.view.calendar;
                this.appointmentform.selected_date = selectInfo.startStr;
                if(moment().format(this.appointmentform.selected_date) >=  moment().format('YYYY-M-DD'))
                {
                    this.$refs['createeventmodal'].show();
                }
                else {

                    this.GetPreviousTasks(this.appointmentform.selected_date);
                }

                calendarApi.unselect(); // clear date selection


            },
            GetPreviousTasks(event_date)
            {
                axios.get('/api/gettasksperday/',{params:{event_date:event_date}}).then(results=>{
                    this.dayevents = results.data;

                    this.selected_date = moment(event_date).format('DD-MMM-yyyy');

                    this.$refs['showevents'].show();


                }).catch(errorEmitt=>{
                    console.log(errorEmitt)
                })
            },

            SubmitTaskForm()
            {
                event.preventDefault();

                axios.post('/api/task/create',{task:this.appointmentform.task,start_date:this.appointmentform.selected_date + ' ' +this.appointmentform.start_time,end_date:this.appointmentform.selected_date + ' ' + this.appointmentform.end_time})
                    .then(result => {


                        if(result.data.status === 200) {
                            this.$refs['createeventmodal'].hide();
                            this.$toasts.push({
                                type: 'success',
                                message: result.data.message,
                            });

                            this.GetTasks();


                        }
                        else {
                            this.$toasts.push({
                                type: 'error',
                                message: result.data.message,
                            });
                        }


                    });
            },
            handleEventClick(clickInfo) {

                this.clickedevent = clickInfo;
                this.$refs['eventmodal'].show();
                // console.log(this.clickedevent);
            },

            handleEvents(events) {
                this.currentEvents = events
            },
            GetTasks()
            {

                axios.post('api/tasks').then(request=>{
                    this.allTasks = request.data
                });

            },
            CurrentTime()
            {
                return moment().format('H:m');
            }
        }
    }
</script>

<template>
    <div class='container-fluid'>
        <div class="py-2">
            <h3 class="text-primary text-center">Appointments</h3>
        </div>

        <div class='row'>
            <div class="col-md-8">
            <FullCalendar
                    class='demo-app-calendar'
                    :options='calendarOptions'
            >
                <template v-slot:eventContent='arg'>
                    <b>{{ arg.timeText }}</b>
                    <i>{{ arg.event.title }}</i>
                </template>
            </FullCalendar>
        </div>
            <div class="col-md-4">
                <div class="py-4">
                    <h5 class="text-center">All Upcoming Appointments</h5>
                </div>
                <div class="container pt-2">
                    <table class="table table-striped">
                        <tbody>
                        <tr v-for="alltask in allTasks">
                            <td>{{alltask.task}}</td>
                            <td>{{alltask.startdate}}</td>
                            <td>{{alltask.enddate}}</td>

                        </tr>
                        </tbody>

                    </table>
                </div>




            </div>
        </div>
        <b-modal ref="eventmodal" id="modal-center"  hide-footer hide-header static>
            <div class="text-center">
               <h1 v-if="clickedevent !=''">{{clickedevent.event.title}}</h1>
            </div>
        </b-modal>
        <b-modal ref="createeventmodal" id="modal-center"  hide-footer hide-header static>
            <div class="text-center">
                <h4 class="text-primary text-weight-500">Add Appointment</h4>
            </div>
            <b-form v-on:submit="SubmitTaskForm">
                <b-form-group
                        id="input-group-1"
                        label="Appointment/Task"
                        label-for="input-1"

                >
                    <b-form-input
                            id="input-1"
                            v-model="appointmentform.task"
                            type="text"
                            class="border"
                            required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                        id="input-group-1"
                        label="Start Time"
                        label-for="input-1"

                >
                <b-form-timepicker v-model="appointmentform.start_time" :placeholder="CurrentTime" locale="en"></b-form-timepicker>
                </b-form-group>
                    <b-form-group
                            id="input-group-1"
                            label="End Time"
                            label-for="input-1"

                    >

                <b-form-timepicker v-model="appointmentform.end_time" locale="en"></b-form-timepicker>
                    </b-form-group>
                <b-form-group
                class="text-center"
                >
                    <button type="submit" class="btn btn-primary">Submit</button>
                </b-form-group>

            </b-form>
        </b-modal>
        <b-modal ref="showevents" id="modal-center"  hide-footer hide-header static>
            <div v-if="dayevents.length > 0">
                <div class="text-center">
                    <h4 class="text-primary text-weight-500">Your Appointments on {{selected_date}}</h4>
                </div>
                <div class="container">
                    <table class="table">
                        <thead>
                        <tr>
                            <td>Task/Appointment</td>
                            <td>Date</td>
                        </tr>

                        </thead>
                        <tbody>
                        <tr v-for="dayevent in dayevents">
                            <td >{{dayevent.task}}</td>
                            <td >{{dayevent.startdate}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-else>
                <div class="text-center">
                    <img style="width:80px; height: auto;" class="py-5" src="/images/embarrassed.png"/>
                    <h4 class="text-dark text-weight-400">Seems you had no appointments on this day</h4>
                </div>
            </div>

        </b-modal>



    </div>
</template>

<style lang='css'>

    h2 {
        margin: 0;
        font-size: 16px;
    }

    ul {
        margin: 0;
        padding: 0 0 0 1.5em;
    }

    li {
        margin: 1.5em 0;
        padding: 0;
    }

    b { /* used for event dates/times */
        margin-right: 3px;
    }

    .demo-app {
        display: flex;
        min-height: 100%;
        font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
        font-size: 14px;
    }

    .demo-app-sidebar {
        width: 300px;
        line-height: 1.5;
        background: #eaf9ff;
        border-right: 1px solid #d3e2e8;
    }

    .demo-app-sidebar-section {
        padding: 2em;
    }

    .demo-app-main {
        flex-grow: 1;
        padding: 3em;
    }

    .fc { /* the calendar root */
        max-width: 1100px;
        margin: 0 auto;
    }

</style>
